import React, { FC, memo } from 'react';
// mui components
import { Grid, Typography, IconButton } from '@mui/material';
// types
import { ITag } from 'redux-store/types';
// icons
import CrossIcon from 'assets/icons/buttons/remove.svg';
// styles
import { tagStyles } from './styles';

interface ITagProps {
  option: ITag;
  bgColor?: string;
  onDelete?: (itemId: number) => void;
}

const Tag: FC<ITagProps> = ({ option: { title, color, id }, onDelete, bgColor }) => {
  return (
    <Grid sx={{ ...tagStyles.tagContainer, backgroundColor: bgColor ?? '#E7ECFF' }}>
      {color ? (
        <Grid
          sx={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: color }}
        ></Grid>
      ) : null}
      <Typography sx={tagStyles.tagInnerText}>{title}</Typography>
      {onDelete ? (
        <IconButton
          component="label"
          onClick={() => {
            onDelete(id);
          }}
        >
          <CrossIcon />
        </IconButton>
      ) : null}
    </Grid>
  );
};

export default memo(Tag);
